<template>
<div class="student-invoice">
    <div v-if="shouldShowForm" class="pb-5">
        <form class="columns row justify-content-center" @submit.prevent="verifyFormValidaity" action="">
            <div class="col-xl-6 col-md-12 col-xs-12">
                <b-field label="Name" class="column" :type="{ 'is-danger': errors.has('name') }" :message="errors.first('name')">
                    <b-input v-validate="'required'" v-model="studentForm.name" type="text" name="name"></b-input>
                </b-field>

                <b-field label="Address" class="column " :type="{ 'is-danger': errors.has('address') }" :message="errors.first('address')">
                    <b-input v-validate="'required'" v-model="studentForm.address" type="text" name="address"></b-input>
                </b-field>

                <b-field label="UTR" class="column " :type="{ 'is-danger': errors.has('utr') }" :message="errors.first('utr')">
                    <b-input v-validate="'required'" v-model="studentForm.utr" type="text" name="utr"></b-input>
                </b-field>

                <b-field label="Invoice number" class="column col-2" :type="{ 'is-danger': errors.has('invoiceNo') }" :message="errors.first('invoiceNo')">
                    <b-input v-validate="'required'" v-model="studentForm.invoiceNo" type="number" name="invoiceNo"></b-input>
                </b-field>

                <b-field label="Account name" class="column " :type="{ 'is-danger': errors.has('account_name') }" :message="errors.first('account_name')">
                    <b-input v-validate="'required'" v-model="studentForm.account_name" type="text" name="account_name"></b-input>
                </b-field>

                <b-field label="Account number" class="column " :type="{ 'is-danger': errors.has('account_no') }" :message="errors.first('account_no')">
                    <b-input v-validate="'required'" v-model="studentForm.account_no" type="text" name="account_no"></b-input>
                </b-field>

                <b-field label="Sort code" class="column " :type="{ 'is-danger': errors.has('short_code') }" :message="errors.first('short_code')">
                    <b-input v-validate="'required'" v-model="studentForm.short_code" type="text" name="short_code"></b-input>
                </b-field>
            </div>
            <div class="col-10 columns justify-content-center">
                <button type="submit" class="ml-5 mt-2 button is-primary"><span>Submit Invoice</span></button>

            </div>
        </form>

        <div class="columns row justify-content-center pb-5">
            <b-field label="Description" class="column col-6">
                <b-input v-model="paymentForm.invoiceDescription" type="text" name="invoiceDescription"></b-input>
            </b-field>

            <b-field label="Amount" class="column col-2">
                <p class="control">
                    <span class="button is-static">£</span>
                </p>
                <b-input expanded v-model="paymentForm.money" type="number" name="money"></b-input>
            </b-field>

            <b-button class="align-self-center" type="is-primary" @click="addNewPayment">Add new amount</b-button>

            <b-table v-if="studentForm.payment" class="col-10" :data="studentForm.payment">
                <b-table-column v-slot="props" label="No." width="40">
                    {{ props.index + 1 }}
                </b-table-column>
                <b-table-column v-slot="props" label="Description" width="80">
                    {{ props.row.invoiceDescription }}
                </b-table-column>
                <b-table-column v-slot="props" label="Student name" width="40">
                    {{ props.row.studentName }}
                </b-table-column>
                <b-table-column v-slot="props" label="Amount" width="20">
                    {{ props.row.money }} £
                </b-table-column>
                <b-table-column v-slot="props" label="Actions" width="20">
                    <b-button type="is-danger" @click="removePayment(props.index)">Remove</b-button>
                </b-table-column>
            </b-table>
        </div>

        <div class="sfe-message">
            <b-icon v-if="isManagement || studentFormComments.length" class="cursor-pointer" @click.native.prevent="showMessageBubble = !showMessageBubble" icon="message-alert" size="is-large" type="is-danger"></b-icon>
            <div class="sfe-message__bubble" v-if="showMessageBubble">
                <div class="pl-5" v-for="(message, index) in studentFormComments" :key="index">
                    <b>{{ message }}</b>
                </div>

                <div class="columnns is-full" v-if="isManagement">
                    <b-field label="Leave a comment for the SFE Form" class="column is-full">
                        <b-input v-validate="'required'" v-model="studentFormComment" type="textarea" name="studentFormComment"></b-input>
                    </b-field>
                    <b-button size="is-med" class="message-send" rounded @click="addCustomMessage()" icon-left="send-circle-outline">
                        Send
                    </b-button>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <InvoicePdf :studentForm="studentForm" :isDownload="isDownload" />
    </div>
</div>
</template>

<script>
import moment from 'moment';
import UtilService from '../../services/util'
import StudentService from "../../services/student.service";
import userService from '../../services/user.service';
import InvoicePdf from '../helpers/InvoicePdf.vue'
export default {
    name: "student-view-mode",
    components: {
        InvoicePdf
    },
    props: ['id', 'studentFormProp', 'templateOptions', 'fullCourse', 'isUpfrontPayment', 'isDownload', 'isEdit'],
    data() {
        return {
            studentForm: {
                name: '',
                address: '',
                utr: '',
                account_name: '',
                account_no: '',
                short_code: '',
                payment: [],
                invoiceNo: 0
            },
            paymentForm: {
                invoiceDescription: '',
                studentName: '',
                money: 0
            },
            initialPaymentForm: {},
            shouldShowForm: true,
            studentFormComments: [],
            studentFormComment: '',
            showMessageBubble: false
        };
    },
    created() {
        if (!this.id) {
            this.$router.push('/payment');
            return
        }

        this.studentFormComments = this.studentFormProp.studentFormComments ? JSON.parse(this.studentFormProp.studentFormComments) : []
        const localFormData = this.$store.state.auth.invoiceData;
        this.valueToCheck = this.isUpfrontPayment ? 'upfrontForm' : 'finalForm'
        if (!this.studentFormProp[this.valueToCheck]) {
            this.studentForm = {
                ...localFormData,
                payment: [],
                date: UtilService.formatDate(Date.now())
            }
        } else {
            this.studentForm = JSON.parse(this.studentFormProp[this.valueToCheck])
        }

        this.shouldShowForm = this.isEdit
        this.paymentForm = {
            invoiceDescription: this.invoiceDescription,
            studentName: this.templateOptions.personalInformation.first_name + ' ' + this.templateOptions.personalInformation.last_name,
            money: 0
        }

        this.initialPaymentForm = UtilService.deepCopy(this.paymentForm)
    },
    computed: {
        isManagement() {
            return UtilService.isManagement()
        },
        invoiceDescription() {
            return `${this.isUpfrontPayment ? 'upfront' : 'final'} comission | ${this.fullCourse.university.title} | ${this.templateOptions.personalInformation.intake} intake`
        }
    },
    watch: {},
    methods: {
        verifyFormValidaity() {
            this.$validator.validateAll().then((isValid) => {
                if (!this.studentForm.payment.length && isValid) {
                    this.warningMoney()
                    return
                } else {
                    const valueToSend = this.isUpfrontPayment ? {
                        studentId: this.id,
                        upfrontForm: JSON.stringify(this.studentForm)
                    } : {
                        studentId: this.id,
                        finalForm: JSON.stringify(this.studentForm)
                    }

                    StudentService.updateSFE(valueToSend).then(() => {
                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `Invoice completed!`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })

                        if(this.isEdit) return

                        this.$store.dispatch('auth/setUserInvoiceNumber', parseInt(this.studentForm.invoiceNo) + 1);

                        userService.updateInvoiceNumber({
                            id: UtilService.currentUserId(),
                            invoiceNo: parseInt(this.studentForm.invoiceNo)
                        })
                    })
                }
            })
        },

        addCustomMessage() {
            this.studentFormComments.push(this.studentFormComment)

            StudentService.updateSFE({
                studentId: this.id,
                studentFormComments: JSON.stringify(this.studentFormComments)
            }).then(() => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `SFE comment submitted`,
                    position: 'is-bottom',
                    type: 'is-success'
                })
            })
        },

        warningMoney() {
            this.$buefy.toast.open({
                duration: 3000,
                message: 'Please add money for your requests',
                position: 'is-bottom',
                type: 'is-danger'
            })
        },

        removePayment(index) {
            this.studentForm.payment.splice(index, 1)
        },

        addNewPayment() {
            if (this.paymentForm.money === 0) {
                this.warningMoney()
                return
            }

            this.studentForm.payment.push(this.paymentForm)
            this.paymentForm = this.initialPaymentForm
        }
    }
};
</script>

<style>
    </style>
